/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterConversationIdKind = (typeof FilterConversationIdKind)[keyof typeof FilterConversationIdKind];

export const FilterConversationIdKind = {
  conversation_id: 'conversation_id',
} as const;
